import * as React from "react";
export const PrePackSelection = React.memo(function PrePackSelection(props) {
    return (React.createElement("p", { className: "rj-prepack__selection", "data-testid": "prepack-selection" },
        React.createElement("span", { className: "rj-prepack__selection-indicator" }),
        React.createElement("span", { className: "rj-prepack__selection-name-wrapper" },
            React.createElement("span", { className: "rj-prepack__selection-name" }, props.name),
            React.createElement("span", { className: "rj-prepack__market-name" }, props.marketName))));
});
//# sourceMappingURL=PrePackSelection.js.map